import React from 'react';
import { chart } from './chartTheme';

/**
 * Compact ranked horizontal bars. Ported from
 * D:\campaigning-system\src\components\charts\BarList.tsx (cos-* tokens; types stripped).
 * `formatValue` (e.g. rupees) replaces the plain number and suffix.
 */
export function BarList({ items, suffix = '', color = chart.teal, className = '', formatValue }) {
  const max = Math.max(...items.map((i) => i.value), 1);
  return (
    <div className={`space-y-3 ${className}`}>
      {items.map((item) => (
        <div key={item.label}>
          <div className="mb-1 flex items-baseline justify-between gap-3 text-[13px]">
            <span className="truncate font-medium text-cos-ink">{item.label}</span>
            <span className="flex shrink-0 items-baseline gap-2">
              {item.meta && <span className="text-2xs text-cos-ink-muted">{item.meta}</span>}
              <span className="mono font-semibold text-cos-ink">
                {formatValue ? formatValue(item.value) : `${item.value}${suffix}`}
              </span>
            </span>
          </div>
          <div className="h-2 overflow-hidden rounded-full bg-[rgba(70,80,72,0.07)]">
            <div
              className="h-full rounded-full transition-[width] duration-700"
              style={{ width: `${(item.value / max) * 100}%`, background: `linear-gradient(90deg, ${chart.tealBright}, ${color})` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default BarList;
